<template>
    <div>
        <a-row type="flex" justify="center">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" class="d-flex d-flex-column">
                <h1>{{ lang.settings.add_excel }}</h1>
                <a-upload-dragger :multiple="false" :before-upload="beforeUpload" class="mb-1 w-100p" :show-upload-list="false" accept=".xlsx,.xlsm,.xlsb,.xltx,.xls">
                    <template v-if="!excel">
                        <p class="ant-upload-drag-icon">
                            <a-icon type="inbox" />
                        </p>
                        <p class="ant-upload-text">{{ lang.settings.file_tip }}</p>
                        <p class="ant-upload-hint">{{ lang.settings.file_tip_help }}</p>
                    </template>
                    <template v-else>
                        <p class="ant-upload-drag-icon">
                            <a-icon type="inbox" />
                        </p>
                        <h2>{{ excel.name }}</h2>
                    </template>
                </a-upload-dragger>
                <a-row type="flex" justify="end" class="w-100p">
                    <a-button :loading="loadings.upload" class="align-self-end mr-1" :disabled="!excel" @click="handleUpload">{{ lang.settings.upload }}</a-button>
                    <a-button :loading="loadings.process" class="align-self-end" :disabled="unloaded" @click="handleImport">{{ lang.settings.process }}</a-button>
                </a-row>

                <p v-if="Object.keys(errors.processing).length">
                    {{mappedErrorResponseResults}}
                </p>
                <ul>
                    <template v-for="(value, attribute, key) in errors.processing">
                        <li v-if="!Array.isArray(value) && Object.keys(value.errors_details).length" :key="key">
                            <span>
                                Hemos encontrado errores en {{attribute}} <a-button type="link" @click="handleShowErrorIndex(key)">{{ key === errorIndex ? 'Ocultar' : 'Ver mas' }}</a-button>
                            </span>
                            <ul class="ml-2" v-if="errorIndex === key">
                                <li v-for="(_value, _attribute, _key) in value.errors_details" :key="_key">
                                    - {{ _value }}
                                </li>
                            </ul>
                        </li>
                    </template>
                </ul>

                <a-row type="flex d-flex-column" class="w-100p">
                    <h1>Imágenes</h1>
                    <small>
                        Esta acción puede tardar unos minutos en completarse, por favor tenga paciencia
                    </small>
                    <!-- <small>
                        Esta acción es opcional, la carga de datos maestros incluye este paso en el proceso de carga de partes y relojes.
                    </small> -->
                    <div class="mt-2">
                        <a-button :loading="loadings.images" @click="refreshImages">
                            Actualizar imágenes
                        </a-button>
                    </div>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import { refreshImages } from '../../api'
export default {
    data: () => ({
        loadings: {
            upload: false,
            process: false,
            images: false
        },
        errors: {
            processing: {}
        },
        errorIndex: null
    }),
    computed: {
        ...mapState({
            excel: state => state.settings.excel,
            unloaded: state => state.settings.unloaded,
        }),
        ...mapGetters({
            lang: 'lang'
        }),
        mappedErrorResponseResults() {
            const processed = Object.values(this.errors.processing)
                .filter(item => !Array.isArray(item))
            
            const watchesCount = processed.reduce((a, b) => a + b.watches, 0)
            const errors = processed.filter(brand => brand.errors > 0)
                .reduce((a, b) => a + b.watches, 0)
            const successful = processed.filter(brand => brand.errors === 0)
                .reduce((a, b) => a + b.watches, 0)
            // console.log(processed, watchesCount, errors,successful)
            return `Se han procesado ${successful} de ${watchesCount} relojes, ${errors} no pudieron ser procesados.`
        }
    },
    methods: {
        handleShowErrorIndex(index) {
            this.errorIndex = index === this.errorIndex ? null : index
        },
        ...mapActions({
            upload: 'settings/upload',
            prepare: 'settings/prepare',
            importExl: 'settings/importExl'
        }),
        ...mapMutations({
            setUnload: 'settings/SET_UNLOAD'
        }),
        handleUpload() {
            this.loadings.upload = !this.loadings.upload
                this.upload()
                .finally(() => this.loadings.upload = !this.loadings.upload)
        },
        handleImport() {
            this.loadings.process = !this.loadings.process
            this.importExl()
                .then(({ data }) => {
                    this.errors.processing = data.result
                })
                .finally(() => this.loadings.process = !this.loadings.process)
        },
        refreshImages() {
            this.loadings.images = !this.loadings.images
            refreshImages()
                .then(() => {
                    this.$notification.open({
                        message: 'Actualización de imágenes.',
                        description: 'El proceso de actualización de imágenes ha comenzado. Este proceso puede tardar incluso 30 minutos o más. Cuando finalice se enviará automáticamente un e-mail a su dirección de correo electrónico registrada en su perfil de usuario.',
                        duration: 0,
                        icon: () => (<a-icon type="smile" style="color: #48BE83" />),
                    });
                })
                .finally(() => this.loadings.images = !this.loadings.images)
        },
        beforeUpload(file) {
            if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                this.$message.error(this.lang.messages.errors.only_excel);
                return false
            }

            this.prepare(file)

            return false
        }
    },
    mounted() {
        this.setUnload(true)
    }
}
</script>
